import React, { memo } from 'react';
import { TouchableOpacity } from 'react-native';
import { Text, IconPlus } from '@redlink/components/atoms';
import { createUseStyle } from '@redlink/assets/styles';

export const AddItemButton = memo(({ placehoder, onPress }) => {
  const { styles } = useStyle();
  return (
    <TouchableOpacity {...{ onPress }} style={styles.container}>
      <Text style={styles.placeholderText}>{placehoder}</Text>
      <IconPlus />
    </TouchableOpacity>
  );
});

const useStyle = createUseStyle(({ colors, size }) => ({
  container: {
    borderWidth: 1,
    borderColor: colors.black3,
    borderRadius: 4,
    overflow: 'hidden',
    paddingHorizontal: 8,
    paddingVertical: 4,
    flexDirection: 'row',
    alignItems: 'center',
    minHeight: 40,
  },
  placeholderText: {
    flex: 1,
    fontSize: 12,
    color: colors.gray21,
    textAlign: 'left',
    marginTop: 3,
  },
}));
